import type { IconSvgObject } from './types';

const Redo03Icon: IconSvgObject = [
  ["path", { d: "M21 8H9C5.68629 8 3 10.6863 3 14C3 17.3137 5.68629 20 9 20H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 12L21 8L17 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Redo03Icon;
